export const historyTabs = {
  RACE: 'race',
  PRACTICE: 'practice',
};

export const EXTERNAL_LINKS = {
  GITHUB: 'https://github.com/devkrafts/KeyBored-support',
  TWITTER: 'https://twitter.com/intent/tweet'
};